<template>
  <ModalFindCustomer
    ref="modal"
    v-if="modalShowFindCustomer"
    @closeModal="closeModalFindCustomer"
    @customer-selected="selectCustomer"
  />
  <ModalDetailTransaction
    ref="modal"
    v-if="modalShowDetailTransaction"
    @closeModal="closeModalDetailTransaction"
    :transactionDetail="transactionDetail"  
  />
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      text="Are you sure you want to delete this transaction?"
      text_class="text-xl font-medium"
      title="Delete Transaction"
    />
  </transition>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader
      class="col-span-2 sm:col-span-1 lg:col-span-2"
      title="Transaction"
      subtitle="Latest Transactions"
    ></PageHeader>
    <div class="col-span-2 sm:col-span-1 lg:col-span-2 flex justify-end items-end">
      <ButtonRouter
        id="new-transaction"
        button_text="&#43; New Transaction"
        path="transaction/new"
        class="w-full md:w-auto"
      />
    </div>

    <div class="row-start-2 col-span-2 lg:col-span-4">
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-center"
      >
        <!-- <span>Start Date</span> -->
        <div>
          <InputForm
            v-model="startDate"
            @change="fetchTransactions()"
            type="date"
            input_class="w-full rounded-3xl"
          />
        </div>
        <!-- <span>End Date</span> -->
        <div>
          <InputForm
            v-model="endDate"
            @change="fetchTransactions()"
            type="date"
            input_class="w-full rounded-3xl"
          />
        </div>
        <!-- <p class="text-sm text-white">Select Branch</p> -->
        <select
          v-model="selectedBranch"
          @change="filterByBranch()"
          class="block text-lg mt-1 flex-1 rounded-3xl border bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
        >
          <option value="" selected class="text-black">All Branches</option>
          <option
            v-for="(branch, index) in allBranches"
            :key="index"
            :value="branch.id"
            class="text-gray-800 text-sm"
          >
            {{ branch.name }}
          </option>
        </select>
        <Button
          button_id="find-customer"
          button_text="Find Customer"
          @click="showModalFindCustomer()"
        />
      </div>
    </div>

    <Card card_class="col-span-2 lg:col-span-4">
      <DinamicTable :header_columns="table_header_transactions">
        <TableRow v-if="filteredTransactions.length <= 0">
          <td
            colspan="7"
            class="p-3 text-center italic text-white tracking-widest"
          >
            ~ No transactions available ~
          </td>
        </TableRow>
        <TableRow
          v-for="(transaction, index) in filteredTransactions"
          :key="index"
        >
          <TableCell>{{
            index + 1 + (pagination.page - 1) * pagination.perPage
          }}</TableCell>
          <TableCell>{{ transaction?.Branch?.name }}</TableCell>
          <TableCell>{{ transaction?.Customer?.name }}</TableCell>
          <TableCell>{{ formatDate(transaction.transaction_date) }}</TableCell>
          <TableCell class="flex gap-1 flex-wrap items-center">
            <span class="bg-white/30 px-2 py-1 rounded-md" v-for="(product, index) in transaction.ProductTransactions" :key="index">
              <p class="font-semibold text-xs">{{ product?.Product?.products_name }} <span class="font-normal">x{{ product?.quantity }}</span></p>
            </span>
          </TableCell>
          <TableCell text_align="right" class="tabular-nums">{{ formatRupiah(transaction.grand_total) }}</TableCell>
          <TableCell>
            <div class="flex items-center gap-2">
              <TableButtonView
                @click="viewDetailTransaction(transaction)"
                :path="`#`"
                :container_id="`btnViewTransaction${transaction.id}`"
              />
              <TableButtonDelete
                @click="deleteTransaction(transaction.id)"
                path="#"
                :container_id="`btnDeleteTransaction${transaction.id}`"
              />
            </div>
          </TableCell>
        </TableRow>
      </DinamicTable>
      <Pagination
        :totalItems="pagination.totalItems"
        :perPage="parseInt(pagination.perPage)"
        :currentPage="parseInt(pagination.page)"
        :previousPageLink="pagination?.previousPageLink"
        :nextPageLink="pagination?.nextPageLink"
        @page-changed="fetchTransactions"
      />
    </Card>
  </section>
</template>

<script>
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import ButtonRouter from "@/components/buttons/ButtonRouter.vue";
import Card from "@/components/organisms/Card.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import InputForm from "@/components/form/InputForm.vue";
import { mapGetters, mapActions } from "vuex";
import { formatRupiah, formatDate } from "@/helpers/formating";
import ModalFindCustomer from "@/components/modals/ModalFindCustomer.vue";
import Button from "@/components/buttons/Button.vue";
import ModalDetailTransaction from "@/components/modals/ModalDetailTransaction.vue";

export default {
  components: {
    ModalDetailTransaction,
    PageHeader,
    DinamicTable,
    Card,
    ButtonRouter,
    TableCell,
    TableRow,
    TableButtonView,
    TableButtonDelete,
    AlertConfirmation,
    Pagination,
    InputForm,
    ModalFindCustomer,
    Button,
  },
  data() {
    return {
      table_header_transactions: [
        "ID",
        "Branch",
        "Customer",
        "Trx Date",
        "Product",
        "Grand Total",
        "Action",
      ],
      alert_confirmation: false,
      animation_alert_confirmation_class: "",
      transaction_id_to_delete: null,
      selectedBranch: "",
      searchQuery: "",
      startDate: "",
      endDate: "",
      modalShowFindCustomer: false,
      selectedCustomer: null,
      modalShowDetailTransaction: false,
      transactionDetail: null,
    };
  },
  created() {
    this.fetchBranches();
    this.fetchTransactions(1);
  },
  computed: {
    ...mapGetters("transactions", ["allTransactions", "pagination"]),
    ...mapGetters("branches", ["allBranches"]),

    filteredTransactions() {
      return this.allTransactions.filter((transaction) => {
        const matchesCustomer = transaction.customer_id
          ? transaction.customer_id.toString().includes(this.searchQuery)
          : false;
          
        return matchesCustomer ;
      });
    },
  },
  methods: {
    formatDate,
    formatRupiah,
    ...mapActions("transactions", [
      "fetchTransactions",
      "deleteTransactionById",
    ]),
    ...mapActions("branches", ["fetchBranches"]),

    async fetchTransactions(page = 1, limit = 10, customer_id = null) {
      const params = {
        page,
        limit,
        branch_id: this.selectedBranch || "",
        start_date: this.startDate || null,
        end_date: this.endDate || null,
        customer_id: customer_id || this.selectedCustomer || null,
      };
      await this.$store.dispatch("transactions/fetchTransactions", params);
    },

    filterByBranch() {
      this.fetchTransactions(1);
    },

    searchTransaction() {
      this.fetchTransactions(1);
    },

    deleteTransaction(transaction_id) {
      this.showAlertConfirmation();
      this.transaction_id_to_delete = transaction_id;
    },

    showAlertConfirmation() {
      this.alert_confirmation = true;
      this.animation_alert_confirmation_class = "animate__backInDown";
    },

    handle_clicked_no() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
    },

    handle_clicked_yes() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.deleteTransactionById(this.transaction_id_to_delete);
      this.fetchTransactions(1);
      this.transaction_id_to_delete = null;
    },
    viewDetailTransaction(transaction) {
      this.transactionDetail = transaction;
      this.modalShowDetailTransaction = true;
    },
    closeModalDetailTransaction() {
      this.modalShowDetailTransaction = false;
    },

    showModalFindCustomer() {
      this.customerToEdit = null;
      this.modalShowFindCustomer = true;
    },

    async closeModalFindCustomer() {
      this.modalShowFindCustomer = false;
      // await this.fetchCustomers();
    },

    selectCustomer(customer) {
      // console.log("new selected customer: ", customer);
      // this.selectedCustomer = customer.id;
      // console.log(this.selectedCustomer);
      this.fetchTransactions(1, 10, customer.id);
    },
  },
};
</script>
